import { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';

export default function Header() {
  const [mobileOpen, setMobileOpen] = useState(false);
  const location = useLocation();

  const navLinks = [
    { to: '/', label: 'Home' },
    { to: '/about', label: 'About' },
    { to: '/programs', label: 'Programs' },
    { to: '/impact', label: 'Impact' },
    { to: '/partnerships', label: 'Partnerships' },
    { to: '/gallery', label: 'Gallery' },
    { to: '/contact', label: 'Contact' },
  ];

  const isActive = (path: string) => location.pathname === path;

  return (
    <>
      {/* Top Bar */}
      <div className="bg-deep text-white/70 text-xs py-2 px-4 md:px-10 hidden md:flex justify-between items-center tracking-wide">
        <span className="flex items-center gap-2">
          Nigeria · Canada · United States &nbsp;·&nbsp; Touching Lives with Compassion and Hope
        </span>
        <span className="flex items-center gap-2">
          <b className="text-gold-light font-medium">FuwaAlesh Foundation</b>
          <span>— Subsidiary</span>
          &nbsp;·&nbsp;
          <Link to="/fuwaalesh" className="text-gold-light hover:underline">Learn more ↗</Link>
        </span>
      </div>

      {/* Main Nav */}
      <nav className="bg-white border-b border-[var(--border)] px-4 md:px-10 flex items-center justify-between sticky top-0 z-50 h-[72px] shadow-[0_1px_12px_rgba(0,0,0,0.05)]">
        <Link to="/" className="flex items-center group">
          <img
            src="/assets/images/logo.png"
            alt="ProArk Haven Foundation"
            className="h-[52px] w-auto"
          />
        </Link>

        {/* Desktop Nav */}
        <div className="hidden lg:flex items-center gap-1">
          {navLinks.map(link => (
            <Link
              key={link.to}
              to={link.to}
              className={`text-[13.5px] px-3.5 py-1.5 rounded-lg transition-all ${
                isActive(link.to)
                  ? 'text-[var(--green)] font-medium'
                  : 'text-muted hover:text-[var(--green)] hover:bg-green-pale'
              }`}
            >
              {link.label}
            </Link>
          ))}
          <Link
            to="/donate"
            className="bg-sub text-white rounded-3xl px-5 py-2 text-[13px] font-medium tracking-wide ml-1 hover:bg-[#8a4d1a] transition-colors"
          >
            Donate Now
          </Link>
        </div>

        {/* Mobile Menu Button */}
        <button
          className="lg:hidden p-2 text-deep hover:text-[var(--green)] cursor-pointer"
          onClick={() => setMobileOpen(!mobileOpen)}
        >
          {mobileOpen ? (
            <svg className="w-6 h-6" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
              <path strokeLinecap="round" strokeLinejoin="round" d="M6 18L18 6M6 6l12 12" />
            </svg>
          ) : (
            <svg className="w-6 h-6" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
              <path strokeLinecap="round" strokeLinejoin="round" d="M4 6h16M4 12h16M4 18h16" />
            </svg>
          )}
        </button>
      </nav>

      {/* Mobile Nav Drawer */}
      {mobileOpen && (
        <div className="lg:hidden bg-white border-b border-[var(--border)] shadow-lg z-40 relative">
          <div className="flex flex-col p-4 gap-1">
            {navLinks.map(link => (
              <Link
                key={link.to}
                to={link.to}
                onClick={() => setMobileOpen(false)}
                className={`text-sm px-4 py-3 rounded-lg transition-all ${
                  isActive(link.to)
                    ? 'text-[var(--green)] font-medium bg-green-pale'
                    : 'text-muted hover:text-[var(--green)] hover:bg-green-pale'
                }`}
              >
                {link.label}
              </Link>
            ))}
            <Link
              to="/donate"
              onClick={() => setMobileOpen(false)}
              className="bg-sub text-white rounded-xl px-4 py-3 text-sm font-medium text-center mt-2 hover:bg-[#8a4d1a] transition-colors"
            >
              Donate Now
            </Link>
          </div>
        </div>
      )}
    </>
  );
}
